import { type Lang, DEFAULT_LANG, getUi } from '../../functions/lib/i18n';

interface InfoSectionProps {
  lang?: Lang;
}

/**
 * Original, human-written content section: a short explainer of how the
 * rankings work plus an FAQ. The FAQ copy is kept identical to the
 * FAQPage JSON-LD rendered server-side in functions/lib/pages.ts (per language).
 */
export function InfoSection({ lang = DEFAULT_LANG }: InfoSectionProps) {
  const ui = getUi(lang);
  return (
    <section className="info-section" aria-label="About YouTubeMost">
      <div className="info-block">
        <h2>{ui.infoTitle}</h2>
        <p>{ui.infoBody}</p>
      </div>

      <div className="info-block">
        <h2>{ui.faqTitle}</h2>
        <dl className="faq-list">
          {ui.faq.map((item) => (
            <div className="faq-item" key={item.q}>
              <dt className="faq-q">{item.q}</dt>
              <dd className="faq-a">{item.a}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
